<template>
  <div class="chart-dialog">
    <el-dialog title="成绩雷达图" :visible.sync="chartDialogShow" width="50%" :before-close="dialogClose">
      <div id="myChart" ref="chart" style="height: 500px; width: 96%; margin: 0 auto"></div>
      <div style="text-align: center">
        <el-button type="primary" round @click="changeChart">切换视图</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: ["chartDialogShow", "courseScoreList"],
  data() {
    return {
      myChart: null,
      isRadar: true
    };
  },
  watch: {
    chartDialogShow(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          // 初始化柱状图
          this.drawRadarChart();
        }, 200);
      }
    },
  },
  mounted() {
    // this.drawRadarChart();
  },
  beforeDestroy() {
    this.clearChart();
  },
  methods: {
    changeChart() {
      // console.log(this.scoreGradeContrastData);
      this.clearChart();
      if (this.isRadar) {
        this.barGraphInit();
      } else {
        this.drawRadarChart(this.scoreGradeContrastData);
      }
      this.isRadar = !this.isRadar;
    },
    // 销毁图例
    clearChart() {
      if (
        this.myChart != null &&
        this.myChart != undefined &&
        this.myChart != ""
      ) {
        this.myChart.dispose();
      }
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:chartDialogShow", false);
      this.clearChart();
    },
    barGraphInit() {
      this.myChart = echarts.init(document.getElementById("myChart"));

      let categories = [];
      let seriesData = [
        { name: "平均分(班级)", type: 'bar', data: [] },
        { name: "平均分(年级)", type: 'bar', data: [] },
        { name: "个人分数", type: 'bar', data: [] },
      ];

      this.courseScoreList.forEach((v, i) => {
        categories.push(v.courseName);
        seriesData[0].data.push(v.classAvgScore);
        seriesData[1].data.push(v.gradeAvgScore);
        seriesData[2].data.push(v.score);
      });

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff", // 悬浮框背景色
          borderColor: "#000", // 悬浮框边框颜色
          borderWidth: 1, // 悬浮框边框宽度
          textStyle: {
            // 悬浮框文字样式
            color: "#000",
            fontSize: 12,
          },
        },
        legend: {
          data: ["平均分(班级)", "平均分(年级)", "个人分数"], // 班级平均分，年级平均分， 个人成绩
        },
        xAxis: {
          type: 'category',
          data: categories,
        },
        yAxis: {
          type: 'value',
        },
        series: seriesData,
      };

      this.myChart.setOption(option);

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
    drawRadarChart() {
      this.myChart = echarts.init(document.getElementById("myChart"));

      let o;
      let arr1 = [];
      let arr2 = [
        { value: [], name: "平均分(班级)" },
        { value: [], name: "平均分(年级)" },
        { value: [], name: "个人分数" },
      ];

      this.courseScoreList.forEach((v, i) => {
        o = {
          text: v.courseName + v.fullScore,
          max: v.fullScore,
        };
        arr1.push(o);
        arr2[0].value.push(v.classAvgScore);
        arr2[1].value.push(v.gradeAvgScore);
        arr2[2].value.push(v.score);
      });

      const option = {
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff", // 悬浮框背景色
          borderColor: "#000", // 悬浮框边框颜色
          borderWidth: 1, // 悬浮框边框宽度
          textStyle: {
            // 悬浮框文字样式
            color: "#000",
            fontSize: 12,
          },
        },
        legend: {
          data: ["平均分(班级)", "平均分(年级)", "个人分数"], // 班级平均分，年级平均分， 个人成绩
        },
        radar: {
          indicator: arr1,
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: arr2,
          },
        ],
      };

      this.myChart.setOption(option);

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./barChartDialog.scss";
</style>